import React, {FC} from "react";
import styled from "styled-components";

const Link = styled.a`
	color: ${({theme}) => theme.color.secondary};
`;

export const TextLink: FC<
	React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
> = (props) => {
	return <Link href={props.href}>{props.children}</Link>;
};
